import React, { HTMLAttributeAnchorTarget, PropsWithChildren } from 'react';

import S from './Link.styled';
import { ILink } from '@/src/types';

type Props = {
  link?: ILink;
  url?: string;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  margin?: string | number;
  target?: HTMLAttributeAnchorTarget;
};

const Link: React.FC<PropsWithChildren<Props>> = ({
  url,
  link,
  onClick,
  disabled,
  target,
  fullWidth,
  margin,
  children,
}) => {
  const commonProps = {
    $disabled: disabled,
    $fullWidth: fullWidth,
    $margin: margin,
  };

  if (url)
    return (
      <S.ExternalLink href={url} target={target} {...commonProps}>
        {children}
      </S.ExternalLink>
    );

  if (link && link.url)
    return (
      <S.ExternalLink href={link.url} target={link.target} {...commonProps}>
        {children}
      </S.ExternalLink>
    );

  if (link && link.cached_url)
    return (
      <S.InternalLink
        to={`/${link.cached_url.replace(/^\//, '')}`}
        target={link.target}
        {...commonProps}
      >
        {children}
      </S.InternalLink>
    );

  if (onClick)
    return (
      <S.Button onClick={onClick} {...commonProps}>
        {children}
      </S.Button>
    );

  return <>{children}</>;
};

export default Link;
